import { useEffect, useState } from 'react'
import { CTA_CTE, MERCADO_PAGO } from '../../constants/mediosEnviosPagos.js'
import { ID_PERFIL_VENDEDOR } from '../../constants/perfiles.js'
import { useAuth } from '../../hooks/useAuth'
import * as usuarioService from '../servicios/usuarioService'
import { obtenerCuentaVinculadaMP } from './useMercadoPago.js'

const vendedoresCtacte = new Map()
const proveedoresPropios = new Map()

const obtenerVendedoresCtaCte = (empid) => {
  if (!vendedoresCtacte.has(empid)) {
    vendedoresCtacte.set(
      empid,
      usuarioService
        .obtenerVendedoresCtaCte(empid)
        .then(({ data }) => data)
        .catch((error) => {
          vendedoresCtacte.delete(empid)
          throw error
        })
    )
  }
  return vendedoresCtacte.get(empid)
}

const obtenerProveedoresPropios = (empid) => {
  if (!proveedoresPropios.has(empid)) {
    proveedoresPropios.set(
      empid,
      usuarioService
        .obtenerProveedoresPropios(empid)
        .then(({ data }) => data)
        .catch((error) => {
          proveedoresPropios.delete(empid)
          throw error
        })
    )
  }
  return proveedoresPropios.get(empid)
}

const obtenerIdsMediosPago = (publicacion) =>
  publicacion?.mediosPagos?.map((medio) =>
    typeof medio === 'object' ? medio.idMedioPago : Number(medio)
  ) || []

export const useDeshabilitaCompra = (publicacion = {}) => {
  const { loginDataContext: { idPerfil, empid, tipoUsuario } = {} } = useAuth()
  const [vendedoresHabilitados, setVendedoresHabilitados] = useState([])
  const [sinCuentaMP, setSinCuentaMP] = useState(false)
  const [idsVendedoresPropios, setIdsVendedoresPropios] = useState(new Set())

  const deshabilitaPorPerfil = idPerfil === ID_PERFIL_VENDEDOR

  useEffect(() => {
    if (!empid) return
    obtenerVendedoresCtaCte(empid)
      .then(setVendedoresHabilitados)
      .catch(() => {
        setVendedoresHabilitados([])
      })
    obtenerProveedoresPropios(empid)
      .then((data) => setIdsVendedoresPropios(new Set(data.map((p) => p.idUsuario))))
      .catch(() => {
        setIdsVendedoresPropios(new Set())
      })
  }, [empid])

  const empidVendedorMP = obtenerIdsMediosPago(publicacion).includes(MERCADO_PAGO)
    ? publicacion.empid
    : null

  useEffect(() => {
    if (!empidVendedorMP) {
      setSinCuentaMP(false)
      return
    }
    let cancelado = false
    obtenerCuentaVinculadaMP(empidVendedorMP)
      .then(({ tieneCuentaVinculadaMP }) => {
        if (cancelado) return
        setSinCuentaMP(!tieneCuentaVinculadaMP)
      })
      .catch(() => {
        if (cancelado) return
        setSinCuentaMP(false)
      })
    return () => {
      cancelado = true
    }
  }, [empidVendedorMP])

  const vendedorHabilitado = (empidVendedor) =>
    vendedoresHabilitados.some((v) => v.empidVendedor === empidVendedor && v.habilita)

  const esProveedorPropio = (idVendedor) => idsVendedoresPropios.has(idVendedor)

  const tieneCtaCte = (item) => obtenerIdsMediosPago(item).includes(CTA_CTE)

  const ctaCteBloqueada = (item) => {
    if (!item.empid) return false
    return (
      !vendedorHabilitado(item.empid) ||
      (tipoUsuario === 'A' && !esProveedorPropio(item.idVendedor))
    )
  }

  const deshabilitarCompra = (item) => {
    const ids = obtenerIdsMediosPago(item)

    if (ids.length === 0) return false

    return (
      (!ids.includes(CTA_CTE) || ctaCteBloqueada(item)) &&
      (!ids.includes(MERCADO_PAGO) || sinCuentaMP)
    )
  }

  const mostrarAvisoCompra = (item) => {
    if (!empid) return false
    return ctaCteBloqueada(item) && tieneCtaCte(item)
  }

  return {
    deshabilitaCompra: deshabilitarCompra(publicacion),
    mostrarAvisoCompra: mostrarAvisoCompra(publicacion),
    deshabilitaCompraPorPerfil: deshabilitaPorPerfil,
    ctaCteBloqueada: tieneCtaCte(publicacion) && ctaCteBloqueada(publicacion),
    mpBloqueado: sinCuentaMP
  }
}
